import { Box, Button, IconButton, Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';

import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
// import { ReactComponent as EditIcon } from '../../../../Assets/img/icons/edit-icon-figma.svg';
import { ReactComponent as DropdownRoundedIcon } from '../../../../Assets/img/icons/dropdown-rounded-figma.svg';
import { ReactComponent as PublicIcon } from '../../../../Assets/img/icons/resume-link-icon.svg';
import { ReactComponent as LocationOnRoundedIcon } from '../../../../Assets/img/icons/resume-location-icon.svg';
import { ReactComponent as EmailRounded } from '../../../../Assets/img/icons/resume-mail-icon.svg';
import { ReactComponent as CallRoundedIcon } from '../../../../Assets/img/icons/resume-phone-icon.svg';

import { useUserDetailContext } from '../../../UserDetailContext';
import { getIconAndLabel } from '../../../Utilities/SocialMediaMapping';
import useApi from '../../../Utilities/useAPI';

import axios from 'axios';

import { DndProvider, useDrag, useDrop } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useDispatch, useSelector } from 'react-redux';
import { getResumeReducer, postResumeReducer } from '../../../../Redux/Reducers/ProfileReducer';

const ModalBox = styled(Box)({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    boxShadow: '0px 12px 24px 0px #919EAB1F, 0px 0px 2px 0px #919EAB33',
    borderRadius: '8px',
    padding: '24px',
    width: "62%",
    maxWidth: "62%",
    maxHeight: "80%",
    overflowY: "auto"
});

// Define the draggable type
const ItemType = "SECTION";

const ResumeGenerate = ({ onClose, handleSuccess, handleFailure, handleAlert, handleInfo }) => {


    const ProfessionalProject = useSelector((state) => state?.ProfileArray?.projectData?.data) || [];
    const ProfessionalExperience = useSelector((state) => state?.ProfileArray?.experienceData?.data);
    const ProfessionalEducation = useSelector((state) => state?.ProfileArray?.educationData?.data);
    const ProfessionalCertificate = useSelector((state) => state?.ProfileArray?.certificateData?.data) || [];
    // console.log("ProfessionalCertificate", ProfessionalCertificate);
    const ProfessionalSoftSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.soft_skills?.skills);

    const ProfessonalToolsSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.professional_tools?.skills);
    const ProfessonalSkills = useSelector((state) => state?.ProfileArray?.professionalSkills?.data?.professional_skills?.skills);

    const ProfessionalData = useSelector((state) => state?.ProfileArray?.professionaProfile?.about_me);
    const ProfessionalDataImage = useSelector((state) => state?.ProfileArray?.professionaProfile);

    const Languages = useSelector((state) => {
        const languages = state?.ProfileArray?.personalProfileLanguages?.data?.language_info;
        return languages ? JSON.parse(languages) : [];
    });

    const monthMap = {
        January: 0,
        February: 1,
        March: 2,
        April: 3,
        May: 4,
        June: 5,
        July: 6,
        August: 7,
        September: 8,
        October: 9,
        November: 10,
        December: 11,
    };

    // Function to create a date object or return a very old date if data is missing
    const getStartDate = (exp) => {
        const year = parseInt(exp.start_year);
        const month = monthMap[exp.start_month];
        if (!isNaN(year) && month !== undefined) {
            return new Date(year, month);
        }
        return new Date(0); // fallback for incomplete data
    };

    const sortedExperience = [...ProfessionalExperience].sort(
        (a, b) => getStartDate(b) - getStartDate(a)
    );

    const sortedCertificates = [...ProfessionalCertificate].sort((a, b) => b.year - a.year);

    const Resumedata = useSelector((state) => state?.ProfileArray?.ResumeData?.data?.[0]);

    const Personaldata = useSelector((state) => state?.ProfileArray?.personalProfile?.data)

    // console.log("professional_toolsprofessional_tools", ProfessonalToolsSkills);

    const { userDetails } = useUserDetailContext();
    const accessToken = localStorage.getItem("objectId");

    const dispatch = useDispatch();
    const { callApiFunction } = useApi();

    const [professionalSocials, setProfessionalSocials] = useState({
        cardName: 'Professional',
        links: []
    })
    const websiteLink = professionalSocials?.links.find((link) => link && (link.network === 'website' && link.visible));
    const profilePicture = ProfessionalDataImage?.user_profile_url ? ProfessionalDataImage?.user_profile_url : userDetails.proFile;

    // Export Menu States and Functions
    const [isLoading, setIsLoading] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleExportClick = (event) => {
        if (anchorEl)
            setAnchorEl(null);
        else
            setAnchorEl(event.currentTarget)
    }

    const handleMenuClose = () => {
        setAnchorEl(null);
    }

    // DND Variables and Functions

    const [Resume, setResume] = useState({
        files: [],
        videos: []
    });
    const updateResume = (arrayName, fileObject, actionType = 'replace') => {
        setResume((prevState) => {
            switch (actionType) {
                case 'add':
                    return {
                        ...prevState,
                        [arrayName]: [...prevState[arrayName], fileObject],
                    };
                case 'remove':
                    return {
                        ...prevState,
                        [arrayName]: prevState[arrayName].filter(file => file.id !== fileObject.id),
                    };
                case 'replace':
                    return {
                        ...prevState,
                        [arrayName]: fileObject, // Assuming fileObject here is the new array of files
                    };
                default:
                    return prevState;
            }
        });
    };
    const [isRearranging, setIsRearranging] = useState(false);

    const [sections, setSections] = useState([
        { id: 'summary', name: "summary", content: ProfessionalData },
        { id: 'projects', name: 'Projects', content: ProfessionalProject },
        { id: 'experience', name: 'Experience', content: sortedExperience },
        { id: 'education', name: 'Education', content: ProfessionalEducation },
        { id: 'certificate', name: 'Certificate', content: sortedCertificates },
        { id: 'skills', name: 'Skills', content: ProfessionalSoftSkills },
        { id: 'professionalskills', name: 'Professional skills', content: ProfessonalSkills },
        { id: 'tools', name: 'Tools', content: ProfessonalToolsSkills },

    ].filter(section => section.content && section.content.length > 0));

    // This function will handle moving sections around
    const moveSection = (fromIndex, toIndex) => {
        const updatedSections = [...sections];
        const [movedSection] = updatedSections.splice(fromIndex, 1);
        updatedSections.splice(toIndex, 0, movedSection);
        setSections(updatedSections);
    };


    const headTags = `
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>${userDetails.name}'s Resume</title>
    `

    const resumeStyles = `
    .profile-resume {color: rgb(0, 0, 0, 0.87); font-family: 'Lato', sans-serif; font-size: 11pt; display: flex; flex-direction: row; }
    .profile-resume .resume-side-content { flex: 0 0 30%; background-color: #F7F9FC; padding: 20px; height: 100vh; min-height: 100vh; }
    .profile-resume .resume-main-body { flex: 0 0 70%; background-color: #ffffff; padding: 24px 16px 24px 16px; position: relative; }
    .resume-main-section { padding-bottom: 20px; padding-left: 20px; }
    .resume-main-body-wrapper .drag-item:not(:last-child) .resume-main-section { border-left: 1px solid #E2E6EE; }
    .resume-side-content .resume-header .resume-profile-container { height: 4rem; width: 4rem; border-radius: 50%; overflow: hidden; }
    .resume-profile-name { font-size: 12pt; font-weight: 700; }
    .resume-profile-headline { font-weight: 700; color: rgba(0, 0, 0, 0.60); }
    .resume-side-content .resume-quote { font-size: 11pt; }
    .resume-side-content .resume-quote-speaker { font-size: 10pt; color: rgba(0, 0, 0, 0.60); }
    .profile-resume .resume-divider { background-color: #EDF0F5; height: 1px; width: 100%; margin: 1rem 0; }
    .profile-resume .resume-contact-list { display: flex; flex-direction: column; gap: 0.5rem; }
    .resume-contact-list a { text-decoration: none; color: unset; }
    .resume-contact-item { display: flex; align-items: center; gap: 0.5rem; }
    .resume-contact-icon-container { border-radius: 50%; height: 24px; width: 24px; background-color: #E2E6EE; display: flex; justify-content: center; align-items: center; }
    .resume-contact-icon { color: #79819A; height: 20px; width: 20px; }
    .resume-contact-label { font-size: 11pt; color: #79819A; }
    .resume-contact-id { font-size: 11pt; color: rgb(0, 0, 0, 0.87); }
    .resume-socials-list { display: grid;  grid-template-columns: repeat(4, 1fr); gap: 10px; }
    .resume-social-icon { height: 28px; width: 28px; }
    .resume-section-title::before { content: '•'; height: 1.5rem; width: 1.5rem; background-color: white; position: absolute; left: -30px; top: -4px;
      border-radius: 50%; display: flex; align-items: center; justify-content: center;
      color: purple; font-size: 14pt; }
    .resume-main-section .resume-section-title { font-size: 12.5pt; font-weight: 700; color: rgb(0, 0, 0, 0.87); margin-bottom: 1rem; position: relative; }
    .resume-project-section .resume-section-body { display: flex; gap: 4px; flex-wrap: wrap; }
    .resume-project-section .resume-section-item { flex: 0 0 46%; /* max-width: 45%;*/ display: flex; flex-direction: column; gap: 8px; padding: 10px; background-color: #F7F9FC; border-radius: 4px; }
    .resume-project-title { font-size: 11pt; font-weight: 700; color: rgb(0, 0, 0, 0.87); margin-bottom: 4px; }
    .resume-project-desc { font-size: 10pt; color: rgba(0, 0, 0, 0.60); }
    .resume-url-div { font-size: 9.5pt; line-height: 14px; -webkit-line-clamp: 1; line-clamp: 1; text-overflow: ellipsis; overflow: hidden; }
    .resume-experience-section .resume-section-body { padding-left: 20px; display: flex; flex-direction: column; }
    .resume-experience-section .resume-section-item { display: flex; justify-content: flex-start; gap: 6px; padding: 4px 0 8px; overflow: hidden; color: rgba(0, 0, 0, 0.60); font-size: 10pt; }
    .resume-exp-content-left .exp-time-location { margin-bottom: 0.25rem; padding-left: 12px; position: relative; }
    .resume-exp-content-left .exp-time-location::before { content: ''; height: 4px; width: 4px; background-color: black; position: absolute; left: 0; top: 4px; border-radius: 50%; }
    .resume-exp-location { display: inline-flex; align-items: center; }
    .resume-exp-icon { height: 14px; width: 14px; margin-right: 2px; }
    .resume-exp-content-left .exp-name-logo { display: flex; gap: 8px; align-items: center; padding-left: 12px; border-left: 1px solid #F7F9FC; margin-left: 1px; }
    .exp-name-logo .resume-exp-logo { height: 34px; width: 34px; overflow: hidden; }
    .resume-exp-logo img { height: 100%;  width: 100%;  object-fit: contain; }
    .resume-exp-name .resume-exp-designation { color: rgba(0, 0, 0, 0.60); font-size: 10pt; }
    .resume-exp-name .resume-exp-company { color: rgb(0, 0, 0, 0.87); font-size: 11pt; }
    .resume-exp-content-left { flex: 1 1 45%; max-width: 45%; }
    .resume-exp-content-right { flex: 0 0 55%; max-width: 45%; font-size: 11pt; color: rgba(0, 0, 0, 0.60); text-overflow: ellipsis; overflow: hidden; }
    .resume-exp-details-1 { padding-left: 44px; } 
    .resume-education-section .resume-section-body { display: flex; flex-wrap: wrap; gap: 4px; }
    .resume-education-section .resume-section-item { flex: 0 0 30%; border-radius: 4px; padding: 6px 12px; background-color: #F7F9FC; display: flex; flex-direction: column; gap: 4px; font-size: 10pt; max-width: 32%; }
    .resume-section-item .edu-name-logo { display: flex; align-items: center; gap: 4px; }
    .resume-section-item .edu-degree-time .resume-edu-degree { font-size: 10pt; font-weight: 700; margin-bottom: 1px; }
    .resume-section-item .edu-degree-time .resume-edu-time { color: rgba(0, 0, 0, 0.60); }
    .resume-section-item .edu-name-logo img { height: 28px; width: 28px; object-fit: contain; overflow: hidden; }
    .resume-skills-section .resume-section-body { display: flex; flex-direction: column; gap: 8px; }
    .resume-section-body .resume-skill-type { flex: 0 0 20%; display: flex; font-weight: 700; }
    .resume-section-body .resume-skills-row { display: flex; gap: 8px; flex-wrap: wrap; flex: 0 0 68%; }
    .resume-skills-row .resume-section-item { border-radius: 4px; padding: 6px 4px; background-color: #F7F9FC; max-width: 70%; overflow: hidden; display: flex; align-items: center; }
    .resume-skill-type.soft-skills-color, .resume-skill-type.soft-skills-color + .resume-skills-row {  color: #9251F7; }
    .resume-skill-type.prof-skills-color, .resume-skill-type.prof-skills-color + .resume-skills-row { color: #516CF7; }
    .resume-tools-section .resume-section-body { display: flex; }
    .resume-section-body .resume-skills-row.resume-tools-row { flex: 0 0 90%; max-width: 90%; }

    /* New styles */
    .resume-exp-logo-1 { height: 36px; width: 36px; overflow: hidden; }
    .resume-exp-right-info>div { margin-bottom: 4px; }
    .exp-time-location-1 { display: inline-flex; align-items: center; }
    .resume-experience-section .resume-section-item { overflow: hidden; color: rgba(0, 0, 0, 0.60); font-size: 9pt; padding: 8px 0; display: unset;}
    .resume-experience-section .resume-section-item:not(:last-child) { border-bottom: 0.7px solid lightgray; }
    .resume-project-section .resume-section-body { display: grid; grid-template-columns: repeat(2, 1fr); gap: 4px; }
    .resume-section-item.full-width { grid-column: 1 / -1; }
    .resume-project-section .resume-section-item { flex: unset; display: flex; flex-direction: column; gap: 8px; padding: 10px; background-color: #F7F9FC; border-radius: 4px; overflow: hidden; max-width: unset; }


    .contain-image, .contain-image-100 { height: 100%; width: 100%; object-fit: contain; }
    .cover-image { height: 100%; width: 100%; object-fit: cover; }
    .span-center-align { display: inline-flex !important; justify-content: center !important; align-items: center !important; }
    .flex-center { display: flex !important; align-items: center !important; justify-content: center !important; }
    .align-items-start { align-items: flex-start !important }
    a { text-decoration: none; color: #0044C6; }
    .line-break { white-space: pre-line; }

    .mb-3 { margin-bottom: 1rem; }
    .mb-2 { margin-bottom: 0.5rem; }
    .mb-1 { margin-bottom: 0.25rem; }
    .me-1 { margin-right: 0.25rem; }
    .ps-3 {padding-left: 1rem}
    .py-2 {padding-top: .5rem !important;padding-bottom: .5rem !important;}
    .gap-1 { gap: 0.25rem; }
    .gap-2 { gap: 0.5rem; }
    .d-flex { display: flex !important; }
    .flex-column { flex-direction: column !important; }
    .justify-content-between { justify-content: space-between !important; }
    .align-items-center { align-items: center !important; }

    @page { size: A4; margin: 2mm 2mm 2mm 2mm; }
    * { box-sizing: border-box; }

    @media print {
        html, body {
        height: 100%;
        }

        .profile-resume {
        page-break-inside: avoid; /* Prevent breaking inside the side content */
        }
    }
`;

    // Utility function to convert a blob URL to a base64 data URL
    const convertImageToBase64 = (imgElement) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'Anonymous';
            img.src = imgElement.src;

            img.onload = () => {
                const canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL('image/png');
                resolve(dataURL);
            };

            img.onerror = () => {
                reject(new Error('Failed to convert image to base64'));
            };
        });
    };

    // API Calling Functions
    const downloadAsPdf = async () => {
        if (Resume.files.length > 0) {
            handleAlert({
                title: "Resume Already Exists",
                message: "You have already generated a resume. Would you like to overwrite the existing resume?",
                continueFn: () => proceedWithPdfGeneration(),
            })
            return;
        }

        await proceedWithPdfGeneration();
    }

    const proceedWithPdfGeneration = async () => {
        setIsLoading(true);
        document.body.style.cursor = 'progress';
        handleInfo('Downloading your Resume...', 1500);

        try {
            const pdfFile = await generatePdf();

            // console.log("GENERATED PDF", pdfFile);
            // const blobUrl = await uploadToBlobStorage(pdfFile);

            // Fetch the PDF as a blob and create a new Blob URL with controlled filename
            // const response = await fetch(blobUrl);
            // const pdfBlob = await response.blob();
            // const newBlobUrl = URL.createObjectURL(pdfBlob);

            // // Download with controlled filename
            // const a = document.createElement('a');
            // a.href = newBlobUrl;
            // a.download = pdfFile.name; // This will be the file name used in the download
            // document.body.appendChild(a);
            // a.click();
            // a.remove();

            // Revoke the temporary URL
            // URL.revokeObjectURL(newBlobUrl);

            // console.log('blobURL:', blobUrl);
            const success = await savePdfToDatabase(pdfFile);
            const sendEmail = await callApiFunction("sendEmailNotificationAfterResumeGeneration", {
                emails: [userDetails?.email]
            });
            console.log(sendEmail);
            if (sendEmail?.success)
                handleSuccess('ResumePDF link shared to email successfully');
            else
                handleFailure('Could not send email with resume link. Try Again Later.');
            handleMenuClose();

            // if (success) {

            //     const blob = new Blob([pdfFile], { type: 'application/pdf' });
            //     const blobUrl = URL.createObjectURL(blob);

            //     const a = document.createElement('a');
            //     a.href = blobUrl;
            //     a.download = "Resume.pdf"; // Set desired file name
            //     document.body.appendChild(a);
            //     a.click();
            //     a.remove();

            //     // Revoke the object URL to free up memory
            //     URL.revokeObjectURL(blobUrl);
            //     // handleSuccess('Downloaded PDF Successfully!');
            // }
            // else {
            //     handleFailure('Could not download PDF. Try Again Later.');
            //     handleMenuClose();
            // }
        } catch (error) {
            console.error('Error processing PDF:', error?.message);
            handleFailure('Could not download PDF. Try Again Later.');
        } finally {
            setIsLoading(false);
            document.body.style.cursor = 'auto';
        }
    };

    const generatePdf = async () => {
        const resumeElement = document.querySelector('.profile-resume');
        const resumeClone = resumeElement.cloneNode(true);
        const imgElements = resumeClone.querySelectorAll('img');

        // Convert all images to base64 format
        for (let imgElement of imgElements) {
            if (imgElement.src.startsWith('https://neoinpublic.blob.core.windows.net/' || 'https://qaneoinindividuals.blob.core.windows.net/')) {
                try {
                    const base64Image = await convertImageToBase64(imgElement);
                    imgElement.src = base64Image;
                } catch (error) {
                    console.error('Failed to convert image to base64:', error);
                }
            }
        }

        const htmlContent = resumeClone.outerHTML;

        // Call backend to generate PDF
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/generate-pdf/resume-pdf`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ headTags, resumeStyles, htmlContent }),
        });

        // Check if the response is OK
        if (!response.ok) {
            throw new Error(`Failed to generate PDF: ${response.statusText}`);
        }

        // If the response is OK, proceed to process it
        const pdfBuffer = await response.blob();

        // Validate if the blob is a valid PDF
        if (pdfBuffer.size < 1024) { // You can set this threshold based on expected size
            throw new Error('Generated PDF file is too small and may be corrupted.');
        }

        // Create a file from the blob with a unique file name
        const file = new File([pdfBuffer], `${userDetails.name} Resume-${Date.now()}.pdf`, { type: 'application/pdf' });

        return file;
    };

    const uploadToBlobStorage = async (file) => {
        const formData = new FormData();
        formData.append('file', file);

        const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return data.url; // The Blob URL
    };

    const savePdfToDatabase = async (file) => {

        // const currentDate = new Date();
        // const formattedDate = currentDate.toLocaleDateString('en-GB').split('/').reverse().join('');
        // const formattedTime = currentDate.toLocaleTimeString('en-GB', { hour12: false }).split(':').join('');

        // const fileObject = {
        //     id: 0, // Initial id as 0, to be updated later
        //     name: `${userDetails.name} Resume-${formattedDate}${formattedTime}.pdf`,
        //     type: 'application/pdf',
        //     data: url,
        //     date: new Date().toLocaleDateString('en-GB'),
        // };

        // const singleDocument = {
        //     document_name: fileObject.name,
        //     document_link: fileObject.data,
        //     document_type: fileObject.type,
        //     is_verified: false,
        //     is_public: false,
        // };

        // Convert Resume.files to match the format required by singleDocument
        // const documents = [...Resume.files.map(file => ({
        //     document_name: file.name,
        //     document_link: file.data,
        //     document_type: file.type,
        //     document_meta: {},
        //     is_verified: file.is_verified || false,
        //     is_public: file.is_public || false,
        // })), singleDocument];

        // const documents = [singleDocument];

        // const updatedDetails = {
        //     section_slug: 'resume_details',
        //     documents: documents,
        // };

        const headers = {
            Authorization: `Bearer ${accessToken}`,
            "x-api-key": process.env.REACT_APP_API_KEY,
            "Content-type": "multipart/form-data"
        }

        const formData = new FormData();

        formData.append('file', file);
        formData.append('section_slug', 'resume_details');
        console.log("FORM DATA", formData);

        try {
            // const response = await callApiFunction('profileUploadDocuments', updatedDetails);
            // const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/userprofile/upload_document`, formData, {
            //     headers: headers
            // })\
            const response = await dispatch(postResumeReducer(formData));


            if (response?.payload?.statusCode === 200) {
                // Convert backend response to fileObject format
                // console.log("RESPONSEEE resumeeeeeee", response?.payload?.data);
                const updatedFiles = response?.payload?.data?.map(doc => ({
                    id: doc.id, // Update the id from the backend
                    name: doc.document_name,
                    type: doc.document_type,
                    data: doc.document_url,
                    date: new Date().toLocaleDateString('en-GB'),
                }));
                // console.log('updatedFiles:', updatedFiles);
                // Replace the entire files array in the Resume context state

                await dispatch(getResumeReducer());
                updateResume('files', updatedFiles, 'replace');


                return true;
            }
        } catch (error) {
            console.error('Error saving PDF to database:', error);
        } finally {
            // console.log('uploaded docs:', documents);
            // console.log('Context Resume:', Resume.files);
        }

        return false;
    };

    const getSocials = async () => {
        try {
            const professionalResponse = await callApiFunction('getCardSocialLink', { cardType: 'Professional' })
            // console.log("professionalResponse", professionalResponse);
            // Transform the response data
            const professionalTransformedLinks = professionalResponse.map((link) => ({
                network: link.info_key,
                url: link.info_value,
                visible: link.is_visible,
            }));

            // Remove duplicates based on the network property
            const professionalUniqueLinks = professionalTransformedLinks.filter((link, index, self) =>
                index === self.findIndex((t) => t.network === link.network)
            );

            // Set the state with unique links
            setProfessionalSocials({
                links: professionalUniqueLinks,
            });
            // console.log("professionalResponse", professionalResponse, "professionalTransformedLinks", professionalTransformedLinks, "professionalUniqueLinks", professionalUniqueLinks); 
        } catch (error) {
            console.error('Error fetching Social Links in Profile:', error);
        }
    }

    useEffect(() => {
        const getResumeInfo = async () => {
            await Promise.all([getSocials()]);
        }

        getResumeInfo();
    }, []);

    return (
        <ModalBox>
            <>
                <div className="modal-heading mb-4">
                    <h5><strong>AI-Generated Resume</strong></h5>
                    <span className='file-attach-icon-container'>
                        <IconButton color="rgb(0, 0, 0, 0.54)" onClick={onClose} disableTouchRipple>
                            <CloseRoundedIcon />
                        </IconButton>
                    </span>
                </div>
                <div>
                    <div className='resume-modal-actions'>
                        {/* <div className="flex-center secondary-text pointer">
                                <IconButton>
                                    <EditIcon />
                                </IconButton>
                                <div>Edit</div>
                            </div> */}
                        <div className='flex-center secondary-text pointer' onClick={() => setIsRearranging(!isRearranging)}>
                            <IconButton sx={{ color: isRearranging && '#0044C6' }} disableRipple>
                                <DragIndicatorIcon />
                            </IconButton>
                            <div className={isRearranging && 'primary-color'}>Re-arrange Sections</div>
                        </div>
                        <Button variant="contained"
                            sx={{ backgroundColor: '#0044C6', padding: '6px 8px 6px 16px' }}
                            onClick={handleExportClick}
                            disableTouchRipple>
                            Export <DropdownRoundedIcon className='ms-1' />
                        </Button>
                        <Menu
                            anchorEl={anchorEl}
                            open={Boolean(anchorEl)}
                            onClose={handleMenuClose}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            className="profile-popup-menu mt-1"
                        >
                            <MenuItem onClick={(isLoading) ? undefined : downloadAsPdf}>
                                <div>As PDF</div>
                            </MenuItem>
                        </Menu>
                    </div>
                    <div className="resume-container">
                        <article className="profile-resume">
                            <section className="resume-side-content">
                                <div className="resume-header mb-3">
                                    <div className="resume-profile-container mb-2">
                                        <img src={profilePicture} alt={userDetails.name} className='cover-image' />
                                    </div>
                                    <div className="resume-profile-name">{userDetails.name}</div>
                                    <div className="resume-profile-headline">{ProfessionalData?.designation}</div>
                                </div>
                                {/* <div className="mb-3">
                                        <div className="resume-quote">
                                            "People ignore design
                                            that ignore people."
                                        </div>
                                        <div className='resume-quote-speaker'>
                                            - Frank Kimiro
                                        </div>
                                    </div> */}

                                <div className="resume-divider" />

                                <div className='resume-contact-list'>
                                    <a href={`mailto:${userDetails?.email}`} target='_blank' rel='noreferrer'>
                                        <div className="resume-contact-item">
                                            <div className='resume-contact-icon-container'><EmailRounded className='resume-contact-icon' /></div>
                                            <div>
                                                <div className='resume-contact-label'>Email</div>
                                                <div className='resume-contact-id'>{userDetails?.email}</div>
                                            </div>
                                        </div>
                                    </a>
                                    {websiteLink &&
                                        <a href={websiteLink?.url} target='_blank' rel='noreferrer'>
                                            <div className="resume-contact-item">
                                                <div className='resume-contact-icon-container'><PublicIcon className='resume-contact-icon' /></div>
                                                <div>
                                                    <div className='resume-contact-label'>Website</div>
                                                    <div className='resume-contact-id'>{websiteLink?.url}</div>
                                                </div>
                                            </div>
                                        </a>
                                    }
                                    <a href={`tel:${userDetails?.phone}`} target='_blank' rel='noreferrer'>
                                        <div className="resume-contact-item">
                                            <div className='resume-contact-icon-container'><CallRoundedIcon className='resume-contact-icon' /></div>
                                            <div>
                                                <div className='resume-contact-label'>Phone</div>
                                                <div className='resume-contact-id'>{userDetails?.phone}</div>
                                            </div>
                                        </div>
                                    </a>
                                    {Personaldata?.address &&
                                        <a
                                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(Personaldata?.address || '')}`}
                                            target='_blank'
                                            rel='noreferrer'
                                        >
                                            <div className="resume-contact-item">
                                                <div className='resume-contact-icon-container'>
                                                    <LocationOnRoundedIcon className='resume-contact-icon' />
                                                </div>
                                                <div>
                                                    <div className='resume-contact-label'>Address</div>
                                                    <div className='resume-contact-id'>{Personaldata?.address}</div>
                                                </div>
                                            </div>
                                        </a>
                                    }
                                </div>

                                <div className="resume-divider" />

                                {(professionalSocials &&
                                    professionalSocials?.links?.filter(link => link.network !== 'website' && link.visible).length !== 0)
                                    &&
                                    <div className="resume-contact-list">
                                        <div className='resume-profile-headline'>Socials</div>
                                        {/* {console.log('professionalSocials', professionalSocials)} */}
                                        <div className="resume-socials-list">
                                            {professionalSocials.links
                                                ?.filter(link => link.network !== 'website' && link.visible)
                                                ?.map((link, index) => {
                                                    return (
                                                        <a key={index} href={link.url} target='_blank' rel='noreferrer'>
                                                            <div>
                                                                {(() => {
                                                                    const { icon: Icon } = getIconAndLabel(link.network);
                                                                    return Icon ? <Icon className='resume-social-icon' /> : null;
                                                                })()}
                                                            </div>
                                                        </a>
                                                    )
                                                })}
                                        </div>
                                    </div>
                                }

                                <div className="resume-divider" />

                                {Languages && Languages.length > 0 && (
                                    <>
                                        <div className="resume-divider" />
                                        <div className="resume-contact-list">
                                            <div className='resume-profile-headline'>Languages</div>
                                            {Languages.map((language, index) => (
                                                <div key={index} className="resume-contact-item">
                                                    <div>
                                                        <div className='resume-contact-id'>{language}</div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </>
                                )}
                            </section>
                            <DndProvider backend={HTML5Backend}>
                                <section className="resume-main-body">
                                    <div className="resume-main-body-wrapper">
                                        {sections.map((section, index) => (
                                            <DragItem key={section.id} index={index} id={section.id} moveSection={moveSection} isRearranging={isRearranging}>
                                                <SectionRenderer section={section} ProfessionalDetails={ProfessionalData} />
                                            </DragItem>
                                        ))}
                                    </div>
                                </section>
                            </DndProvider>
                        </article>
                    </div>
                </div>
            </>
        </ModalBox>
    )
}

export default ResumeGenerate

const DragItem = ({ id, index, moveSection, isRearranging, children }) => {
    const ref = React.useRef(null);

    const [{ handlerId }, drop] = useDrop({
        accept: 'SECTION',
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            };
        },
        hover(item, monitor) {
            if (!ref.current) {
                return;
            }
            const dragIndex = item.index;
            const hoverIndex = index;

            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return;
            }

            const hoverBoundingRect = ref.current?.getBoundingClientRect();
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 4;
            const clientOffset = monitor.getClientOffset();
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;

            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }

            moveSection(dragIndex, hoverIndex);
            item.index = hoverIndex;
        },
    });

    const [{ isDragging }, drag] = useDrag({
        type: 'SECTION',
        item: { id, index },
        canDrag: isRearranging,
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    const opacity = isDragging ? 0 : 1; // Adjust opacity during dragging

    drag(drop(ref)); // Attach both drag and drop refs to the same element

    return (
        <div
            ref={ref}
            style={{ opacity }} // Apply opacity
            className={`drag-item ${isDragging ? 'dragging' : ''} ${isRearranging ? 'drag-item-active' : ''}`}
        >
            {children}
        </div>
    );
};

const SectionRenderer = ({ section, ProfessionalDetails }) => {

    const hasContent = (content) => content && Array.isArray(content) && content.length > 0;

    // Helper function to filter public items
    const filterPublicItems = (items) => items?.filter(item => item && item.is_public);


    switch (section.id) {
        case 'summary':
            return section.content ? (
                <section className="resume-main-section">
                    <div className="resume-section-title">Summary</div>
                    {section.content &&
                        <div>
                            <div className="resume-project-desc">{section?.content}</div>
                        </div>
                    }
                </section>) : "";

        case 'projects':
            const validProjects = filterPublicItems(section.content);
            return hasContent(validProjects) ? (
                <section className="resume-main-section">
                    <div className="resume-project-section">
                        <div className="resume-section-title">Projects</div>
                        <div className="resume-section-body">
                            {section.content
                                ?.filter((project) => project && project.is_public) // Corrected property name
                                ?.map((project, index, filteredProjects) => {
                                    const isOdd = filteredProjects.length % 2 !== 0;
                                    const isFullWidth = isOdd && index === 0;

                                    return (
                                        <div
                                            className={`resume-section-item ${isFullWidth ? 'full-width' : ''}`}
                                            key={index}
                                        >
                                            <div className="resume-project-item">
                                                <div className="resume-project-title">{project?.project_name}</div>
                                                <div className="resume-project-desc">{project.project_description}</div>
                                            </div>
                                            {/* <div>
                                                {project?.attachments
                                                    ?.filter((attachment) => attachment?.document_type === 'url')
                                                    ?.map((attachment, idx) => (
                                                        <div className='resume-url-div' key={idx}>
                                                            <a href={attachment?.document_url} target='_blank' rel='noreferrer'>
                                                                {attachment?.document_name || `Link ${idx + 1}`}
                                                            </a>
                                                        </div>
                                                    ))
                                                }
                                            </div> */}
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </section>
            ) : null;

        case 'experience':
            const validExperiences = filterPublicItems(section.content);

            return hasContent(validExperiences) ? (
                <section className="resume-main-section">
                    <div className="resume-experience-section">
                        <div className="resume-section-title">Experience</div>
                        <div className="resume-section-body">
                            {section.content
                                ?.filter((experience) => experience && experience.is_public) // Fixed filtering
                                ?.map((experience, index) => (
                                    <div key={index} className="resume-section-item">
                                        <div className="resume-exp-content-left">
                                            <div className="exp-time-location">
                                                <span className='me-1'>
                                                    {experience?.start_month} {experience?.start_year} -
                                                    {experience?.is_currently_working ? 'Present' : `${experience?.end_month} ${experience?.end_year}`}
                                                </span>
                                                <span className='resume-exp-location'>
                                                    <LocationOnRoundedIcon className='resume-exp-icon' />
                                                    <span>{experience?.location} • {experience?.location_type}</span>
                                                </span>
                                            </div>
                                            <div className="exp-name-logo">
                                                {experience?.company_logo && (
                                                    <div className="resume-exp-logo">
                                                        <img src={experience?.company_logo} alt='logo' className='contain-image' />
                                                    </div>
                                                )}
                                                <div className="resume-exp-name">
                                                    <div className="resume-exp-designation mb-1">{experience?.role_title}</div>
                                                    <div className="resume-exp-company">{experience?.company_name}</div>
                                                </div>
                                            </div>
                                        </div>
                                        {experience?.details&&<div className="resume-project-desc line-break ps-3 py-2">
                                            {experience?.details || ""}
                                        </div>}
                                    </div>
                                ))}
                        </div>
                    </div>
                </section>
            ) : null;

        case 'education':
            const validEducation = filterPublicItems(section.content);
            return hasContent(validEducation) ? (
                <section className="resume-main-section">
                    <div className="resume-education-section">
                        <div className="resume-section-title">Education</div>
                        <div className="resume-section-body">
                            {section.content
                                ?.filter((education) => education && education.is_public) // Corrected property name
                                ?.map((education, index) => (
                                    <div className="resume-section-item" key={index}>
                                        <div className="edu-name-logo">
                                            {education?.logo_link && (
                                                <img src={education.logo_link} alt="Institute Logo" />
                                            )}
                                            <div>{education?.institute_name}</div>
                                        </div>
                                        <div className="edu-degree-time">
                                            <div className='resume-edu-degree'>
                                                {education?.educational_level === 'UG' ? education?.degree : education?.educational_level}
                                            </div>
                                            <div className='resume-edu-time'>
                                                {education?.start_year} - {education?.is_pursuing ? 'Present' : education?.end_year}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                </section>
            ) : null;
        case 'certificate':
            const validCertificate = filterPublicItems(section.content);
            return hasContent(validCertificate) ? (
                <section className="resume-main-section">
                    <div className="resume-education-section">
                        <div className="resume-section-title">Certificate</div>
                        <div className="resume-section-body">
                            {section.content
                                ?.filter((certificate) => certificate && certificate?.is_public) // Corrected property name
                                ?.map((certificate, index) => (
                                    <div className="resume-section-item" key={index}>
                                        <div className="edu-name-logo">
                                            {certificate?.certificate_logo && (
                                                <img src={certificate?.certificate_logo} alt="Institute Logo" />
                                            )}
                                            <div>{certificate?.course_name}</div>
                                        </div>
                                        <div className="edu-degree-time">
                                            <div className='resume-edu-degree'>
                                                {certificate?.organisation_name}
                                            </div>
                                            <div className='resume-edu-time'>
                                                {certificate?.issue_date} - {certificate?.year}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                </section>
            ) : null;

        case 'skills':
            const hasSoftSkills = hasContent(section.content);
            return (hasSoftSkills) ? (
                <section className="resume-main-section">
                    <div className="resume-skills-section">
                        <div className="resume-section-title">Skills</div>
                        <div className="resume-section-body">
                            {hasSoftSkills && (
                                <div className="d-flex flex-column gap-2">
                                    <div className="resume-skill-type soft-skills-color">Soft Skills</div>
                                    <div className="resume-skills-row">
                                        {section.content.map((skill, index) => (
                                            <div className="resume-section-item word-break" key={index}>
                                                {skill}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            ) : null;
        case 'professionalskills':
            const hasProfSkills = hasContent(section.content);
            // const hasProfSkills = hasContent(ProfessionalDetails?.profSkills);
            return (hasProfSkills) ? (
                <section className="resume-main-section">
                    <div className="resume-skills-section">
                        {/* <div className="resume-section-title">Skills</div> */}
                        <div className="resume-section-body">
                            {hasProfSkills && (
                                <div className="d-flex flex-column gap-2">
                                    <div className="resume-skill-type soft-skills-color">Professional Skills</div>
                                    <div className="resume-skills-row">
                                        {section.content.map((skill, index) => (
                                            <div className="resume-section-item word-break" key={index}>
                                                {skill}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </section>
            ) : null;

        case 'tools':
            return hasContent(section.content) ? (
                <section className="resume-main-section">
                    <div className="resume-tools-section">
                        <div className="resume-section-title">Tools</div>
                        <div className="resume-section-body">
                            <div className="resume-skills-row resume-tools-row">
                                {section?.content.map((tool, index) => (
                                    <div className="resume-section-item word-break" key={index}>{tool}</div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            ) : null


        default:
            return null;
    }
};